import objectFitImages from 'object-fit-images';
objectFitImages();//object-fitのie対応